"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DataAccessor_1 = require("../../DOM/HTMLElement/DataAccessor");
class BrowserStorage {
    constructor(engine) {
        this.engine = engine;
        this.dataAccessor = new DataAccessor_1.default((storageEngine, key) => storageEngine.getValue(key), (storageEngine, key, value) => storageEngine.setValue(key, value));
    }
    clear() {
        this.engine.clear();
    }
    keys() {
        return this.engine.keys();
    }
    remove(key) {
        this.engine.remove(key);
    }
    getInt(key, defaultValue) {
        return this.dataAccessor.getInt(this.engine, key, defaultValue);
    }
    getIntOrNull(key, defaultValue) {
        return this.dataAccessor.getIntOrNull(this.engine, key, defaultValue);
    }
    getFloat(key, defaultValue) {
        return this.dataAccessor.getFloat(this.engine, key, defaultValue);
    }
    getFloatOrNull(key, defaultValue) {
        return this.dataAccessor.getFloatOrNull(this.engine, key, defaultValue);
    }
    getString(key, defaultValue) {
        return this.dataAccessor.getString(this.engine, key, defaultValue);
    }
    getStringOrNull(key, defaultValue) {
        return this.dataAccessor.getStringOrNull(this.engine, key, defaultValue);
    }
    getJson(key, defaultValue) {
        return this.dataAccessor.getJson(this.engine, key, defaultValue);
    }
    getJsonOrNull(key, defaultValue) {
        return this.dataAccessor.getJsonOrNull(this.engine, key, defaultValue);
    }
    setInt(key, value) {
        this.dataAccessor.setInt(this.engine, key, value);
    }
    setFloat(key, value) {
        this.dataAccessor.setFloat(this.engine, key, value);
    }
    setString(key, value) {
        this.dataAccessor.setString(this.engine, key, value);
    }
    setJson(key, value) {
        this.dataAccessor.setJson(this.engine, key, value);
    }
}
exports.default = BrowserStorage;
//# sourceMappingURL=BrowserStorage.js.map